<template>
    <div>
        <div class="breadcrumb-container">
            <v-breadcrumbs :items="breadcrumbsItem"></v-breadcrumbs>
        </div>
        <div class="header header-container">
            <div class="text-header">
                {{ $vuetify.lang.t('$vuetify.statusAttendanceForm.viewAttendance') }}
            </div>
        </div>
        <div class="attendance-form-container locale-font">
            <v-card class="attendance-profile content-container">
                <v-container class="pa-attendance">
                    <v-row class="ma-0 card-header">
                        {{ $vuetify.lang.t('$vuetify.statusAttendanceForm.profile') }}
                    </v-row>
                    <v-row>
                        <v-col cols="3" class="pt-0 profile-container">
                            <upload-image
                                :canDelete="false"
                                :isEditing="false"
                                :img="imgProfile(form.employeeImg)"  />
                        </v-col>
                        <v-col cols="9" class="pt-0">
                            <v-row>
                                <v-col cols="6">
                                    <div class="form-label">
                                        {{ $vuetify.lang.t('$vuetify.statusAttendanceForm.employeeId') }}
                                    </div>
                                    <div class="form-text text-ellipsis">{{ form.employeeNo }}</div>
                                </v-col>
                                <v-col cols="6">
                                    <div class="form-label">
                                        {{ $vuetify.lang.t('$vuetify.statusAttendanceForm.employeeFullname') }}
                                    </div>
                                    <div class="form-text text-ellipsis-12">{{ form.employeeFullname }}</div>
                                </v-col>
                                <v-col cols="6">
                                    <div class="form-label">
                                        {{ $vuetify.lang.t('$vuetify.statusAttendanceForm.email') }}
                                    </div>
                                    <div class="form-text text-ellipsis">{{ form.email }}</div>
                                </v-col>
                                <v-col cols="6">
                                    <div class="form-label">
                                        {{ $vuetify.lang.t('$vuetify.statusAttendanceForm.position') }}
                                    </div>
                                    <div class="form-text text-ellipsis">{{ form.position }}</div>
                                </v-col>
                                <v-col cols="12">
                                    <div class="form-label">
                                        {{ $vuetify.lang.t('$vuetify.statusAttendanceForm.bureau') }}
                                    </div>
                                    <div class="form-text text-ellipsis">{{ form.bureau }}</div>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
            <v-card class="attendance-detail content-container" :class="checkPunchLogs()" >
                <v-container class="pa-attendance-detail">
                    <v-row class="ma-0 card-header-detail">
                        {{ $vuetify.lang.t('$vuetify.statusAttendanceForm.attendanceDetail') }}
                    </v-row>
                    <div v-for="(item, index) in form.punchLogs" :key="index">
                        <div class="gray-line" v-if="index>0"></div>
                        <v-row>
                            <v-col cols="3" class="pt-0">
                                <div class="punch-log-label">
                                    {{ $vuetify.lang.t('$vuetify.statusAttendanceForm.date') }}
                                </div>
                                <div class="punch-log-text">{{ item.date }}</div>
                            </v-col>
                            <v-col cols="3" class="pt-0">
                                <div class="punch-log-label">
                                    {{ $vuetify.lang.t('$vuetify.statusAttendanceForm.time') }}
                                </div>
                                <div class="punch-log-text">{{ item.time }}</div>
                            </v-col>
                            <v-col cols="6" class="pt-0">
                                <div class="punch-log-label">
                                    {{ $vuetify.lang.t('$vuetify.statusAttendanceForm.method') }}
                                </div>
                                <div class="punch-log-text">{{ item.methodText }}</div>
                            </v-col>
                            <!-- method face scan --->
                            <v-col cols="6" class="pt-2">
                                <div class="mb-2 punch-log-label">
                                    {{ $vuetify.lang.t('$vuetify.statusAttendanceForm.attachment') }}
                                </div>
                                <div class="image-location">
                                    <img class="image-display" :src="item.snap_f_path" />
                                </div>
                            </v-col>
                            <v-col cols="6" class="pt-1" v-if="item.method==='FAC'">
                                <v-row>
                                    <v-col cols="12" class="pt-4">
                                        <div class="punch-log-label">
                                            {{ $vuetify.lang.t('$vuetify.statusAttendanceForm.temperature') }}
                                        </div>
                                        <div class="punch-log-text">{{ item.temperature }}</div>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" class="pt-4">
                                        <div class="punch-log-label">
                                            {{ $vuetify.lang.t('$vuetify.statusAttendanceForm.location') }}
                                        </div>
                                        <div class="punch-log-text">{{ item.device_name }}</div>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <!-- method checkin by line --->
                            <v-col cols="12" class="pt-0" v-else>
                                <div class="mb-2 punch-log-label">
                                    {{ $vuetify.lang.t('$vuetify.statusAttendanceForm.location') }}
                                </div>
                                <div class="rectangle-address pointer" @click="openGoogleMap(item)" v-if="item.address">
                                    <div class="mr-2 location"><i class="fas fa-map-marker-alt"></i></div>
                                    <div class="address">{{ item.address }}</div>
                                    <div class="ml-2 time">{{ item.time }}</div>
                                </div>
                                <div class="mt-4 image-location" v-if="item.attachment_f_path">
                                    <img class="image-display" :src="item.attachment_f_path" />
                                </div>
                            </v-col>
                        </v-row>
                    </div>
                    <div class="punch-log-text" v-if="form.punchLogs.length === 0">
                        {{ $vuetify.lang.t('$vuetify.statusAttendanceForm.thereIsNoPunchLog') }}
                    </div>
                </v-container>
            </v-card>
        </div>
    </div>
</template>

<script>
import UploadImage from '@/components/UploadImage'
import profileDefault from '@/assets/user_default.png'

export default {
    name: 'StatusAttendanceForm',

    components: {
        UploadImage
    },

    computed: {
        breadcrumbsItem () {
            return [
                {
                    text: this.$vuetify.lang.t('$vuetify.inquiry.inquiryAndAttendance'),
                    disabled: false,
                    exact: true,
                    to: {
                        name: 'StatusAttendance'
                    }
                },
                {
                    text: this.$vuetify.lang.t('$vuetify.statusAttendanceForm.viewAttendance'),
                    disabled: true
                }
            ]
        }

    },

    data () {
        return {
            form: {
                employeeImg: null,
                employeeNo: null,
                employeeFullname: null,
                email: null,
                position: null,
                bureau: null,
                punchLogs: []
            },
            attendanceId: null
        }
    },

    methods: {
        imgProfile (img) {
            if (img) {
                return img
            } else {
                return profileDefault
            }
        },

        async loadData (id) {
            this.$store.dispatch('setLoading', true)
            const url = `attendance/detail/${id}`
            const res = await this.axios.get(url)
            this.$store.dispatch('setLoading', false)
            if (res && res.data && res.data.status === 'ok') {
                this.form = res.data.data
            }
        },

        createActivityDateTime (item) {
            return item.date + ' ' + item.time
        },

        createActivityMessage (item) {
            return this.$vuetify.lang.t('$vuetify.manageAttendanceForm.activityMessage')
                .replace('$checkinTime', item.checkinTime)
                .replace('$userName', item.username)
        },

        openGoogleMap (item) {
            if (item.lat && item.lon) {
                const url = `https://www.google.com/maps/search/?api=1&query=${item.lat},${item.lon}`
                window.open(url, '_blank')
            }
        },

        checkPunchLogs () {
            return this.form.punchLogs.length > 0 ? '' : 'card-default'
        }
    },

    async mounted () {
        this.attendanceId = this.$route.params.id
        await this.loadData(this.attendanceId)
    },

    watch: {
        '$vuetify.lang.current': {
            handler: async function (after, before) {
                await this.loadData(this.attendanceId)
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
    .header-container {
        display: flex;
        justify-content: space-between;
        margin-bottom: 1rem;
    }

    .pa-attendance {
        padding: 20px 40px 40px 40px;
    }

    .pa-attendance-detail {
        padding: 20px 40px 20px 40px;
    }

    .attendance-form-container {
        display: grid;
        min-height: 100%;
        height: 100%;
        margin-bottom: 1rem;
        grid-gap: 25px;
        grid-template-columns: calc(60% - 12.5px) calc(40% - 12.5px);
        color: white;

        .card-header {
            font-size: 24px;
            margin-bottom: 20px !important;
        }

        .card-header-detail {
            font-size: 24px;
            margin-bottom: 20px !important;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        .form-label {
            font-size: 14px;
            color: #6c6c6c;
            line-height: 1.29;
            margin-bottom: 5px;

            &:not(:first-child) {
                margin-top: 23px;
            }
        }

        .form-text {
            font-family: 'Roboto';
            font-size: 16px;
            line-height: 1.19;
            color: #131410;
        }

    }
    .attendance-profile {
        grid-column: 1 / 1;
    }
    .attendance-detail {
        grid-column: 2 / 2;
        grid-row: 1 / 3;
    }

    .text-ellipsis {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .text-ellipsis-12 {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 500px;
    }

    .content-container {
        box-shadow: 0 5px 25px 0 rgba(0, 0, 0, 0.05);
        border-radius: 15px !important;
    }

    .image-location {
        display: flex;
        position: relative;
        padding: 0;
    }

    .image-display {
        border-radius: 10px;
        width: 100%;
    }

    .gray-line {
        border-top: solid 1px #c7c7c7;
        margin-top: 20px;
        margin-bottom: 30px;
    }

    .punch-log-label {
        font-size: 14px;
        color: #6c6c6c;
    }

    .punch-log-text {
        font-size: 16px;
        color: #131410;
    }

    .d-flex-wrap {
        display: flex;
        flex-wrap: wrap;
    }

    .rectangle-address {
        display: flex;
        justify-content: space-between;
        margin: 10px 0 0;
        padding: 17px 15px 19px;
        border-radius: 10px;
        font-family: 'Roboto';
        font-size: 16px;

        background-color: #f9f1e6;

        .location {
            color: #e8ac8f !important;
            width: 15px;
        }

        .address {
            color: #131410;
            text-align: left;
        }
        .time {
            width: 40px;
            color: #a8a8a8;
            text-align: right;
            margin: 0 0 0 30px !important;
        }
    }

    .upload-image-container {
        width: 120px;
    }

    .card-default {
        height: 280px
    }

    ::v-deep .breadcrumb-container .v-breadcrumbs {
        padding-bottom: 18px;
    }
</style>
